<template>
  <div>
    <modal
      name="aboutModal"
      :scrollable="true"
      delay="2000"
      width="100%"
      height="auto"
      style="z-index: 9998;"
      @closed="closeModal"
    >
      <div id="modalAreaAbout" class="modalArea">
        <div class="content">
          <h2>ぎふの旅フォトスポットサイトとは</h2>
          <p>
            標高3,000ｍを超える山岳地帯から、県内をあまねく流れる清流まで、<br>
            「飛山濃水」とも呼ばれる特色ある自然を有する岐阜県<br>
            豊かな自然のもと育まれた歴史や文化は<br>
            今も人々の暮らしに息づいています。<br>
            <br>
            この自然・歴史・文化という、今日まで受け継がれてきた魅力の発信と<br>
            まだ知られていない新しい魅力の発掘のため<br>
            「ぎふの旅フォトコンテスト」を開催し、多くの秀逸な作品をご応募いただきました。<br>
            <br>
            この「ぎふの旅フォトスポットサイト」では、<br>
            選りすぐりの作品を、撮影スポットとともに紹介しています。<br>
            カメラ片手に、岐阜県の魅力を写す旅に出かけてみませんか？<br>
            <br>
      ＜リンク＞<br>
      ・フォトコンテスト詳細はこちら：<a href="https://gifu.tokyocameraclub.com/contest2021/" target="_blank">https://gifu.tokyocameraclub.com/contest2021/</a><br>
      ・岐阜県観光連盟公式Instagramはこちら：<a href="https://www.instagram.com/visit.gifupref/" target="_blank">https://www.instagram.com/visit.gifupref/</a><br>
      ・岐阜県の観光情報はこちら：<a href="https://www.kankou-gifu.jp/" target="_blank">https://www.kankou-gifu.jp/</a>
          </p>
        </div><!-- /content -->
      </div><!-- /modalArea -->
      <div v-if="open" class="closeModalBotton fade" @click="closeModal"><img src="/img/blank.gif"></div>
    </modal>
  </div>
</template>

<script>
export default {
  props: [
    'open'
  ],
  methods: {
    closeModal () {
      this.$emit('update:open', false)
      this.$modal.hide('aboutModal')
      const path = '/'
      if (path !== this.$route.path) {
        this.$router.push(path)
        document.title = 'ぎふの旅フォトスポットサイト'
      }
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.$modal.show('aboutModal')
      }
    }
  }
}
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.8) !important;
}
.vm--modal {
  background-color:rgba(0,0,0,0) !important;
}
</style>
